import { useState } from "react";
import { useNavigate } from "react-router";
import BackLink from "../../../components/atoms/BackLink";
import KarteTemplateForm, {
  KarteTemplateFormType,
} from "../../../components/features/KarteTemplateForm";
import { UnprocessableEntityError } from "../../../errors";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import { KarteTemplateFormInterface } from "../../../interfaces/KarteTemplateInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import { useCreateKarteTemplate } from "./useCreateKarteTemplate";

interface Props {
  section: SectionInterface;
}

const SectionsSettingsKarteTemplatesNew = (props: Props) => {
  const [apiErrors, setApiErrors] = useState<ApiErrorInterface[]>([]);
  const navigate = useNavigate();

  const createKarteTemplate = useCreateKarteTemplate({
    sectionId: props.section.id,
  });
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const handleCreateTemplate = (values: KarteTemplateFormInterface) => {
    createKarteTemplate.mutate(values, {
      onSuccess: () => {
        showSuccessMessage("テンプレートを作成しました");
        navigate(`/sections/${props.section.id}/settings/karte_templates`);
      },
      onError: (error) => {
        showErrorMessage("テンプレートを作成できませんでした");
        if (error instanceof UnprocessableEntityError) {
          setApiErrors(error.originalErrors);
        }
      },
    });
  };

  return (
    <>
      <BackLink>戻る</BackLink>
      <KarteTemplateForm
        type={KarteTemplateFormType.New}
        sectionId={props.section.id}
        karteTemplate={null}
        submitting={createKarteTemplate.isPending}
        loading={false}
        onSubmit={handleCreateTemplate}
        apiErrors={apiErrors}
      />
    </>
  );
};

export default SectionsSettingsKarteTemplatesNew;
